import * as Sentry from '@sentry/react'
import { filtrarBreadcrumb } from './sentryFiltros'

Sentry.init({
  dsn: process.env.REACT_APP_GLITCHTIP_DSN,
  release: process.env.REACT_APP_RELEASE,
  // Separa hmg de prod no Sentry; o Amplify exporta a variável no build (homologacao/producao).
  environment: process.env.REACT_APP_SENTRY_ENVIRONMENT,

  tracesSampleRate: 0.01,
  autoSessionTracking: false,
  beforeBreadcrumb: filtrarBreadcrumb,
})
